// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yy-base-element-tooltip-cont * {
  color: #FFF;
}
.ynf-lib-pro.yy-base-element-wrap {
  -webkit-flex: 0 1 auto;
          flex: 0 1 auto;
  width: 100%;
  display: -webkit-flex;
  display: flex;
  min-height: 32px;
  -webkit-align-items: center;
          align-items: center;
}
.ynf-lib-pro.yy-base-element-wrap .yy-base-element-label {
  width: 110px;
  padding-right: 8px;
  text-align: right;
  -webkit-justify-content: flex-end;
          justify-content: flex-end;
  -webkit-align-items: center;
          align-items: center;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-flex;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #333333;
}
.ynf-lib-pro.yy-base-element-wrap .yy-base-element-content {
  -webkit-flex: 1 1;
          flex: 1 1;
  font-weight: 400;
  font-size: 13px;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-flex;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  -webkit-align-items: center;
          align-items: center;
  width: 100%;
}
.ynf-lib-pro.yy-base-element-wrap .yy-base-element-content-vertical {
  -webkit-flex: 1 1 auto;
          flex: 1 1 auto;
  font-weight: 400;
  font-size: 13px;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-flex;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  -webkit-align-items: center;
          align-items: center;
  width: 100%;
}
.ynf-lib-pro.yy-base-element-wrap .yy-base-element-tipicon {
  line-height: 1;
  font-weight: 100;
  color: #999;
}
.ynf-lib-pro.yy-base-element-wrap.horizontal-label {
  -webkit-flex-direction: row;
          flex-direction: row;
}
.ynf-lib-pro.yy-base-element-wrap.vertical-label {
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-align-items: stretch;
          align-items: stretch;
  -webkit-flex-grow: 0;
          flex-grow: 0;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
.ynf-lib-pro.yy-base-element-wrap.vertical-label .yy-base-element-label {
  -webkit-flex: 1 1 auto;
          flex: 1 1 auto;
  width: auto;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
}
.ynf-lib-pro.yy-base-element-wrap.invalid .wui-input-affix-wrapper {
  border-color: #f44336 !important;
}
.ynf-lib-pro.yy-base-element-wrap.hidden {
  display: none;
}
.ynf-lib-pro.yy-base-element-wrap .required-star {
  color: red;
  font-style: normal;
  font-size: 16px;
  padding: 0px;
  -webkit-transform: scale(0.5);
          transform: scale(0.5);
}
`, "",{"version":3,"sources":["webpack://./src/utils/hocWithBaseElementWrap/index.less"],"names":[],"mappings":"AAAA;EAEI,WAAA;AAAJ;AAII;EACE,sBAAA;UAAA,cAAA;EACA,WAAA;EACA,qBAAA;EAAA,aAAA;EACA,gBAAA;EAEA,2BAAA;UAAA,mBAAA;AAHN;AAHI;EAQI,YAAA;EACA,kBAAA;EACA,iBAAA;EAEA,iCAAA;UAAA,yBAAA;EACA,2BAAA;UAAA,mBAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;EACA,qBAAA;EAAA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAHR;AApBI;EA2BI,iBAAA;UAAA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;EACA,qBAAA;EAAA,aAAA;EAGA,gBAAA;EACA,uBAAA;EACA,sCAAA;UAAA,8BAAA;EACA,2BAAA;UAAA,mBAAA;EACA,WAAA;AANR;AAlCI;EA4CI,sBAAA;UAAA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;EACA,qBAAA;EAAA,aAAA;EAGA,gBAAA;EACA,uBAAA;EACA,sCAAA;UAAA,8BAAA;EACA,2BAAA;UAAA,mBAAA;EACA,WAAA;AATR;AAhDI;EA6DI,cAAA;EACA,gBAAA;EACA,WAAA;AAVR;AAaM;EACE,2BAAA;UAAA,mBAAA;AAXR;AAcM;EACE,8BAAA;UAAA,sBAAA;EACA,4BAAA;UAAA,oBAAA;EACA,oBAAA;UAAA,YAAA;EACA,sBAAA;UAAA,cAAA;AAZR;AAQM;EAOI,sBAAA;UAAA,cAAA;EACA,WAAA;EAEA,mCAAA;UAAA,2BAAA;AAbV;AAiBM;EAEI,gCAAA;AAhBV;AAoBM;EACE,aAAA;AAlBR;AAzEI;EA+FI,UAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;UAAA,qBAAA;AAnBR","sourcesContent":[".yy-base-element-tooltip-cont {\n  * {\n    color: #FFF;\n  }\n}\n.ynf-lib-pro {\n    &.yy-base-element-wrap {\n      flex: 0 1 auto;\n      width: 100%;\n      display: flex;\n      min-height: 32px;\n      // min-width: 310px;\n      align-items: center;\n      .yy-base-element-label {\n        width: 110px;\n        padding-right: 8px;\n        text-align: right;\n        // display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        word-break: break-all;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        display: flex;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 20px;\n        color: #333333;\n      }\n  \n      .yy-base-element-content {\n        flex: 1;\n        font-weight: 400;\n        font-size: 13px;\n        word-break: break-all;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        display: flex;\n        // line-height: normal;\n        // max-height: 32px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n      }\n\n      .yy-base-element-content-vertical {\n        flex: 1 1 auto;\n        font-weight: 400;\n        font-size: 13px;\n        word-break: break-all;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        display: flex;\n        // line-height: normal;\n        // max-height: 32px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n      }\n  \n      .yy-base-element-tipicon {\n        line-height: 1;\n        font-weight: 100;\n        color: #999;\n      }\n  \n      &.horizontal-label {\n        flex-direction: row;\n      }\n  \n      &.vertical-label {\n        flex-direction: column;\n        align-items: stretch;\n        flex-grow: 0;\n        flex-shrink: 0; \n  \n        .yy-base-element-label {\n          flex: 1 1 auto;\n          width: auto;\n          // text-align: left;\n          justify-content: flex-start;\n        }\n      }\n  \n      &.invalid {\n        .wui-input-affix-wrapper {\n          border-color: #f44336 !important\n        }\n      }\n  \n      &.hidden {\n        display: none;\n      }\n  \n      .required-star {\n        color: red;\n        font-style: normal;\n        font-size: 16px;\n        padding: 0px;\n        transform: scale(0.5);\n      }\n    }\n} "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
